import { render } from "./Box.vue?vue&type=template&id=7452b799"
import script from "./Box.vue?vue&type=script&lang=ts"
export * from "./Box.vue?vue&type=script&lang=ts"
script.render = render

export default script